import * as actions from "../actions/communicationActions";

const initialState = {
  data: {},
  showSidePanel: false,
  errors: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_WORKFLOW:
      return {
        ...state,
        [action.event]: action.workflow,
      };

    case actions.SET_WORKFLOW:
      return {
        ...state,
        [action.event]: action.workflow,
      };
    case actions.SET_ACTIVE_WORKFLOW_ID:
      return {
        ...state,
        activeWorkflowId: action.activeWorkflowId,
      };
    case actions.SET_SIDE_PANEL:
      return {
        ...state,
        showSidePanel: action.showSidePanel,
      };
    case actions.SET_ACTIVE_WORKFLOW_ERRORS:
      return {
        ...state,
        errors: action.errors,
      };

    default:
      return state;
  }
}
